export default __webpack_public_path__ + "static/media/Aetonix_wallpaper.b69ad405.png";